function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
// -----
import 'cross-fetch/polyfill';
import { saveBlacklist, updateFormState } from '@engine/actions/creators/blacklist';
import Button from '@engine/components/presentational/base/button';
import Error from '@engine/components/presentational/base/error';
import Icon from '@engine/components/presentational/base/icon';
import Loader from '@engine/components/presentational/base/loader';
import Panel from '@engine/components/presentational/base/panel';
import React from 'react';
import SelectField from '@engine/components/presentational/base/select-field';
import SelectMultiField from '@engine/components/presentational/base/select-multi-field';
import TabField from '@engine/components/presentational/base/tab-field';
import TextField from '@engine/components/presentational/base/text-field';
import { connect } from 'react-redux';

var BlacklistNewForm = /*#__PURE__*/function (_React$Component) {
  _inherits(BlacklistNewForm, _React$Component);

  var _super = _createSuper(BlacklistNewForm);

  function BlacklistNewForm(props) {
    var _this;

    _classCallCheck(this, BlacklistNewForm);

    _this = _super.call(this, props);
    _this.state = {
      ownerOption: 'base',
      whitelist: _this.props.whitelist
    };
    return _this;
  }

  _createClass(BlacklistNewForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var nameField = this.findField('name');
      var valueField = this.findField('value');
      var commentField = this.findField('comment');
      var ownerIdField = this.findField('blacklist_owner_id');
      var mccField = this.findField('mcc');
      return React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-md-10 col-lg-8 col-xl-7"
      }, React.createElement(Panel.Container, null, React.createElement(Panel.Header, null, React.createElement(Icon, {
        icon: "".concat(this.props.whitelist ? 'check' : 'ban-circle')
      }), " ", this.props.title), React.createElement(Panel.Body, null, this.errorMessage(), React.createElement(SelectField, {
        name: "name",
        label: nameField.label,
        options: nameField.options,
        onChange: function onChange(value) {
          return _this2.updateName(value);
        },
        value: this.props.form.name
      }), this.alternativeValueField ? React.createElement(SelectField, {
        name: "value",
        label: this.alternativeValueField.label,
        key: this.props.form.name,
        options: this.alternativeValueField.options,
        onChange: function onChange(value) {
          return _this2.updateValue(value);
        },
        value: this.props.form.value
      }) : React.createElement(TextField, {
        name: "value",
        label: valueField.label,
        onChange: function onChange(value) {
          return _this2.updateValue(value);
        },
        value: this.props.form.value
      }), React.createElement(TextField, {
        name: "comment",
        label: commentField.label,
        onChange: function onChange(value) {
          return _this2.updateComment(value);
        }
      }), React.createElement(TabField, {
        name: "blacklist_type",
        label: "Blacklist Type",
        value: this.state.ownerOption,
        options: [['Base', 'base'], ['By MCC', 'by_contract_mcc']],
        onChange: function onChange(value) {
          return _this2.updateType(value);
        }
      }), this.state.ownerOption === 'base' && React.createElement(SelectField, {
        name: ownerIdField.name,
        label: ownerIdField.label,
        options: ownerIdField.options,
        onChange: function onChange(value, name, option) {
          return _this2.updateOwner(value, name, option);
        },
        value: ""
      }), this.state.ownerOption === 'by_contract_mcc' && React.createElement("div", null, React.createElement(TabField, {
        name: ownerIdField.name,
        label: ownerIdField.label,
        value: "Terminal",
        options: [['Terminal', 'Terminal'], ['Merchant', 'Merchant']],
        onChange: function onChange(value) {
          return _this2.updateOwner('', '', {
            type: value
          });
        }
      }), React.createElement(SelectMultiField, {
        name: "mcc",
        label: "Merchant category codes",
        options: mccField.options,
        onChange: function onChange(value) {
          return _this2.updateMcc(value);
        }
      }))), this.footer)));
    }
  }, {
    key: "footer",
    get: function get() {
      var _this3 = this;

      return React.createElement(Panel.Footer, null, React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
      }), React.createElement("div", {
        className: "col-lg-4 col-lg-offset-4 col-md-4 col-md-offset-4 col-sm-4 col-sm-offset-4"
      }, !this.props.isSaving && !this.props.isSaved && React.createElement(Button, {
        type: "success",
        className: "btn-block",
        onClick: function onClick() {
          return _this3.save();
        }
      }, this.props.button_text), this.props.isSaving && React.createElement(Loader, {
        message: 'Saving...',
        position: "horizontal-center",
        color: "refined-blue"
      }), this.props.isSaved && !this.props.hasSaveError ? React.createElement(Loader, {
        message: 'Created successfully! Redirecting...',
        position: "horizontal-center",
        color: "refined-green",
        icon: "ok"
      }) : '', this.props.isSaved ? this.redirect() : '')));
    }
  }, {
    key: "findField",
    value: function findField(fieldName) {
      return this.props.fields.find(function (field) {
        return field.name === fieldName;
      });
    }
  }, {
    key: "alternativeValueField",
    get: function get() {
      var _this4 = this;

      var valueField = this.props.alternative_value_fields.find(function (field) {
        return field.name === _this4.props.form.name;
      });
      return valueField;
    }
  }, {
    key: "errorMessage",
    value: function errorMessage() {
      var _this5 = this;

      var baseError = 'base';

      if (this.props.hasSaveError) {
        var errorsKeys = Object.keys(this.props.errors);

        if (errorsKeys[0] === baseError) {
          return React.createElement(Error, null, this.props.errors[baseError][0]);
        }

        return React.createElement(Error, null, React.createElement("strong", null, "There were problems with the following fields:"), React.createElement("ul", null, errorsKeys.map(function (key) {
          return React.createElement("li", {
            key: key
          }, " ", key, " ", _this5.props.errors[key][0]);
        })));
      }
    }
  }, {
    key: "redirect",
    value: function redirect() {
      if (this.props.hasSaveError) {
        return;
      }

      window.location.replace(this.props.url);
    }
  }, {
    key: "updateName",
    value: function updateName(name) {
      this.props.updateFormState({
        name: name,
        value: ''
      });
    }
  }, {
    key: "updateValue",
    value: function updateValue(value) {
      this.props.updateFormState({
        value: value
      });
    }
  }, {
    key: "updateComment",
    value: function updateComment(comment) {
      this.props.updateFormState({
        comment: comment
      });
    }
  }, {
    key: "updateType",
    value: function updateType(type) {
      this.setState({
        ownerOption: type
      });
      this.props.updateFormState({
        blacklist_owner_type: type === 'base' ? '' : 'Terminal',
        blacklist_owner_id: '',
        type: type
      });
    }
  }, {
    key: "updateOwner",
    value: function updateOwner(id, _name, option) {
      this.props.updateFormState({
        blacklist_owner_type: option.type,
        blacklist_owner_id: id
      });
    }
  }, {
    key: "updateMcc",
    value: function updateMcc(code) {
      this.props.updateFormState({
        merchant_category_codes: code
      });
    }
  }, {
    key: "save",
    value: function save() {
      var form = this.props.form;
      var url = form.type === 'base' ? this.props.url : this.props.bulk_url;
      this.props.saveBlacklist(url, {
        blacklist: _objectSpread(_objectSpread({}, this.props.form), {}, {
          whitelist: this.props.whitelist
        })
      });
    }
  }]);

  return BlacklistNewForm;
}(React.Component);

export default connect(function (state) {
  return {
    isSaving: state.blacklist.isSaving,
    isSaved: state.blacklist.isSaved,
    hasSaveError: state.blacklist.hasSaveError,
    errors: state.blacklist.errors,
    message: state.blacklist.message,
    form: state.blacklist.form
  };
}, {
  saveBlacklist: saveBlacklist,
  updateFormState: updateFormState
})(BlacklistNewForm);